<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_date: moment(new Date()).format("DD-MM-YYYY"),
      id: this.$route.params.id,
      totals:{
        totalin:0,
        totalout:0,
    },
    };
  },
  computed: {
    ...mapGetters("customers", [
        "CustomerBalanceDetails"
    ]),
  },
  methods: {
    ...mapActions({
        FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
    }),
  },

  watch: {
    CustomerBalanceDetails(newValue){
      if(newValue == true){
        this.FetchBalanceDetails();
      }
    }
  },

  updated() {
    let total_in = 0;
    let total_out = 0;
    if(this.CustomerBalanceDetails){
        this.CustomerBalanceDetails.forEach((item)=>{
            total_in = total_in+parseInt(item.amountIn);
        });
        this.totals.totalin = total_in;
        this.CustomerBalanceDetails.forEach((item)=>{
            total_out = total_out+parseInt(item.amountOut);
        });
        this.totals.totalout = total_out;

        setTimeout(() => {
            window.onafterprint = window.close;
            window.print();
            window.history.back();
        }, 2000)
    }
  },
  created() {
    this.FetchBalanceDetails(this.id);
  },
};
</script>

<style scoped>
/* .print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
} */
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">       

        <div class="bg-white p-2">
          <div class="print-font" style="padding-left: 15px">
            <table width="100%" class="mt-3">
                <b-spinner
                    v-if="!CustomerBalanceDetails"
                    class="m-0"
                    variant="primary"
                    role="status"
                ></b-spinner>
                <tr v-else>
                <td width="100%" style="text-align: right; padding-right: 15px !important">
                  <center>
                    <img v-if="CustomerBalanceDetails[0].business2.Businesslogo" :src="CustomerBalanceDetails?CustomerBalanceDetails[0].business2.Businesslogo:''" height="80" /> 
                    <strong style="font-size: calc(1.2671875rem + 0.20625vw)">
                    {{
                      CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.name : "---"
                    }}</strong
                  >
                  <p>
                    <span>
                      {{
                        CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.address : "---"
                      }}</span
                    >
                    <br />
                    <strong>Tel: </strong
                    >{{
                      CustomerBalanceDetails
                        ? "+256" + CustomerBalanceDetails[0].business2.phone1
                        : "---"
                    }}
                    <br />
                    <strong>Email: </strong
                    >{{ CustomerBalanceDetails ? CustomerBalanceDetails[0].business2.email : "---" }}
                  </p>
                  </center>
                </td>
              </tr>
            </table>
            <hr style="border-style: dashed; width: 97%" />
            <h5
              style="
                text-align: center;
                font-weight: bold;
                font-family: Courier New, Courier, Lucida Sans Typewriter,
                  Lucida Typewriter, monospace;
              "
            >
              <span>
                <strong>
                  CUSTOMER PAYMENT REPORT
                  <br/> FOR {{ CustomerBalanceDetails[0].customer.name.toUpperCase() }} - {{ CustomerBalanceDetails[0].customer.contact }}<br/>
                  Page - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.page:'' }} Chassis - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.chassis:'' }}
                   No.Plate - {{ CustomerBalanceDetails[0].records?CustomerBalanceDetails[0].records.noplate:'' }}<br/>
                  AS OF {{ current_date }}</strong
                ></span
              >
              <br />
            </h5>
            <h4>Details</h4>
            <center>
              <table width="100%" class="table" style="font-size: 15px">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Date</th>
                    <th>Amount In</th>
                    <th>Amount Out</th>
                    <!-- <th>Description</th> -->
                    <th>Category</th>                    
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in CustomerBalanceDetails" :key="r">
                    <td>{{ r + 1 }}</td>
                    <td>{{ record.date }}</td>
                    <td>{{ record.amountIn.toLocaleString() }}</td>
                    <td>{{ record.amountOut.toLocaleString() }}</td>
                    <!-- <td>{{ record.Description }}</td> -->
                    <td>{{ record.Category }}</td>                    
                    <td>{{ record.newbalance }}</td>
                  </tr>
                </tbody>
              </table>
            </center>
            <span class="row text-center">
                <h5>Total In: <span class="text-danger">{{totals.totalin?(totals.totalin).toLocaleString():0}}</span></h5>
               
                <h5>Total Out: <span class="text-danger">{{totals.totalout?(totals.totalout).toLocaleString():0}}</span></h5>

                <h5>Total Balance: <span class="text-danger">{{(totals.totalout - totals.totalin)?(totals.totalout - totals.totalin).toLocaleString():0}}</span></h5>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
